import { PopoverProps } from '@material-ui/core/Popover'
import React from 'react'
import ThemedPopover from './ThemedPopover'

function mapClasses(classes: IClassnames): string {
  return Object.keys(classes).reduce((a: string, b: string) => {
    return classes[b] === false ? a : a.concat(` ${b}`)
  }, '')
}

function Popover({
                   withArrow,
                   classes,
                   offsetRight,
                   ...rest
                 }: IPopoverProps & PopoverProps) {
  const paper = mapClasses({
    'popover--paper': true,
    'popover--paper--with_arrow': withArrow,
  })

  return (
    <ThemedPopover
      offsetRight={offsetRight}
      classes={{ ...classes, paper }}
      style={rest.style}
      {...rest}
    />
  )
}

export default Popover

export interface IPopoverProps {
  withArrow?: boolean
  offsetRight?: number
}

interface IClassnames {
  [key: string]: boolean
}
